import { Button, Result } from 'antd';
import { useTranslation } from 'react-i18next';

export function ErrorPage() {
  const { t } = useTranslation();
  return (
    <Result
      status="500"
      title="500"
      subTitle={t('errorPage.internal')}
      extra={
        <Button type="primary" size="large" href="/">
          {t('errorPage.backToTop')}
        </Button>
      }
    />
  );
}
